var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "video-courses" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "sub-header" },
        slot: "sub-header"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-10" }, [
            _c(
              "nav",
              { staticClass: "navbar navbar-toggleable navbar-light" },
              [
                _c("ul", { staticClass: "nav navbar-nav" }, [
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/video-courses" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "video_lectures.sub_header.video_courses"
                                )
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item active" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link typography--body-3",
                          attrs: { to: "/video-lectures" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "video_lectures.sub_header.video_lectures"
                                )
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2 hidden-xs-down" }, [
            _c(
              "div",
              { staticClass: "sub-header-btn-row" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "btn btn-primary new-video-course-btn float-right",
                    attrs: { to: "/upload-video-lecture" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("video_lectures.sub_header.new_video_lecture")
                        ) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-27",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _c(
              "div",
              { staticClass: "row" },
              [
                _vm.lectures.length === 0
                  ? _c("div", { staticClass: "col-12 text-center mb-5 pb-5" }, [
                      _c("div", { staticClass: "empty-list-text" }, [
                        _c("div", {
                          staticClass:
                            "typography--body-2 typography--color-disabled",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("video_lectures.no_lectures")
                            )
                          }
                        })
                      ])
                    ])
                  : _vm._l(_vm.lectures, function(videoLecture) {
                      return _c(
                        "div",
                        {
                          key: videoLecture.id,
                          staticClass: "col-sm-6 col-md-4 col-lg-3"
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "card-row",
                              attrs: {
                                to: "/video-lectures/" + videoLecture.id,
                                tag: "div"
                              }
                            },
                            [
                              _c("VideoLectureItem", {
                                attrs: { lecture: videoLecture }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                _vm._v(" "),
                _c(
                  "InfiniteLoading",
                  {
                    ref: "infiniteLoading",
                    staticClass: "w-100",
                    attrs: { "on-infinite": _vm.onInfinite }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "spinner" }, slot: "spinner" },
                      [
                        _c("LoadingBounce"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typography--body-2 typography--color-disabled pb-5"
                          },
                          [_vm._v(_vm._s(_vm.$t("common.loading")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 text-center mb-5 pb-5",
                      attrs: { slot: "no-more" },
                      slot: "no-more"
                    })
                  ]
                )
              ],
              2
            )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-417e449a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-417e449a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/video-lectures/views/VideoLectureList.vue
// module id = shMJ
// module chunks = 1